<template>
    <div class="list_container">
        <ul class="list" v-if="listData.length">
            <li v-for="(item, index) in listData" :key="index" @click="jumpReportDetail(item)">
                <div>AI视力报告-{{ item.type == 0 ? '标准版' : '高级版' }}</div>
                <div>{{ getTime(item.createdAt) }}</div>
            </li>
        </ul>
        <div class="no_list" v-else>
            <img src="../../assets/img/report/no_list.png" alt="">
            <div>抱歉，当前没有任何报告。</div>
            <van-button type="default" @click="jumpCreateReport()">生成AI视力报告</van-button>
        </div>
        <div class="loading" v-if="show">
            <van-loading size="30px" vertical color="#3BD3C1">加载中...</van-loading>
        </div>
    </div>
</template>

<script>
import { getRecordApi } from "@/api/record.js";
import { getReportListApi } from "@/api/report.js";
import { getStudentId } from "@/utils/auth.js";
export default {
  data() {
    return {
      show: true,
      listData: []
    };
  },
  created() {
    this.getReportList();
  },
  methods: {
    //
    async isTest() {

    },
    //获取打卡报表
    getReportList() {
      getReportListApi({
        studentId: getStudentId()
      }).then(res => {
        console.log(res)
        if (res.data && res.data.length) {
          res.data.map(item => {
            // let id = "";
            // let idArr = item.aiInfoId.c;
            // idArr.forEach(v => {
            //   id += String(v);
            // });
            // item.aiInfoId = id
            item.aiInfoId = item.aiInfoId.toString()
          });
          this.listData = res.data;
        }
        this.show = false
      });
    },
    //跳转生成报告
    async jumpCreateReport() {
      let luoyan = false;
      let quguang = false;
      await getRecordApi({
        studentId: getStudentId(),
        type: 1
      }).then(res => {
        console.log('裸眼'+!res.data.data.length)
        luoyan = !res.data.data.length
      });
      await getRecordApi({
        studentId: getStudentId(),
        type: 2
      }).then(res => {
        console.log('屈光'+!res.data.data.length)
        quguang = !res.data.data.length
      });
      if(luoyan || quguang) {
        this.$dialog.alert({
          title: '生成失败',
          message: '缺少学生视力筛查数据',
        }).then(() => {
          // on close
        });
      } else {
        this.$router.push({ name: "ReportCreate" });
      }
    },
    //跳转报告详情
    jumpReportDetail(item) {
      this.$router.push({ name: "ReportDetail", query: { 'aiInfoId': item.aiInfoId } });
    },
    getTime(time) {
      let date = new Date(time * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      return `${Y}-${M < 10 ? "0" + M : M}-${D < 10 ? "0" + D : D}`;
    }
  }
};
</script>

<style scoped>
.loading {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #f5f5f5;
    z-index: 99999;
}

.loading > .van-loading {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%,-50%)
}

.list_container {
  height: calc(100vh - 0.2rem);
  padding: 0.1rem;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

li {
  height: 0.38rem;
  padding: 0.2rem;
  margin-bottom: 0.1rem;
  background-color: #ffffff;
  border-radius: 0.1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #131415;
  letter-spacing: 0;
  font-weight: 400;
  line-height: 0.16rem;
}

li > div:last-child {
  font-size: 0.12rem;
  color: #707070;
  line-height: 0.12rem;
}

.no_list {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no_list > img {
  width: 0.9rem;
  height: 0.9rem;
  margin-top: 1.12rem;
}

.no_list > div {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.16rem;
  color: #707070;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  line-height: 0.16rem;
}

.no_list > button {
  width: calc(100% - 0.4rem);
  margin-top: 0.6rem;
  background-color: #3bd3c1;
  border-radius: 0.1rem;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.16rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
</style>